/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Menu } from './components/registration/Menu'
import { ProductGridColumn } from './components/registration/ProductGridColumn'
import { OrderGridColumn } from './components/registration/OrderGridColumn'
import { CustomerGridColumn } from './components/registration/CustomerGridColumn'
import { ProductMassAction } from './components/registration/ProductMassAction'
import { OrderMassAction } from './components/registration/OrderMassAction'
import { OrderViewButton } from './components/registration/OrderViewButton'
import { MassActionBannerNotification } from './components/registration/MassActionBannerNotification'
import { OrderCustomFee } from './components/registration/OrderCustomFee'
import { Extensible } from './components/extensible/Extensible'
import { updateMenu } from './components/registration/utils'
import { CustomerMassAction } from './components/registration/CustomerMassAction'
import { OrderViewButtonBannerNotification } from './components/registration/OrderViewButtonBannerNotification'

export const pushRegistrations = (config) => {
  const menuRootSelector = '#uix-menu-placeholder'
  const menuElement = ReactDOM.createRoot(
    document.querySelector(menuRootSelector)
  )
  menuElement.render(
    <React.StrictMode>
      <Extensible extensions={config.extensions}>
        {config.registrationUrl &&
          config.registrationUrl.menu &&
          (config.menuItems ? (
            updateMenu(
              config.registrationUrl.menu,
              menuRootSelector,
              config.menuItems
            )
          ) : (
            <Menu
              url={config.registrationUrl.menu}
              rootElmSelector={menuRootSelector}
            />
          ))}
        {config.registrationUrl && config.registrationUrl.productGridColumn && (
          <ProductGridColumn url={config.registrationUrl.productGridColumn} />
        )}
        {config.registrationUrl && config.registrationUrl.orderGridColumn && (
          <OrderGridColumn url={config.registrationUrl.orderGridColumn} />
        )}
        {config.registrationUrl &&
          config.registrationUrl.customerGridColumn && (
            <CustomerGridColumn
              url={config.registrationUrl.customerGridColumn}
            />
          )}
        {config.registrationUrl && config.registrationUrl.productMassAction && (
          <ProductMassAction url={config.registrationUrl.productMassAction} />
        )}
        {config.registrationUrl && config.registrationUrl.orderMassAction && (
          <OrderMassAction url={config.registrationUrl.orderMassAction} />
        )}
        {config.registrationUrl &&
          config.registrationUrl.customerMassAction && (
            <CustomerMassAction
              url={config.registrationUrl.customerMassAction}
            />
          )}
        {config.registrationUrl && config.registrationUrl.orderViewButton && (
          <OrderViewButton url={config.registrationUrl.orderViewButton} />
        )}
        {config.registrationUrl &&
          config.registrationUrl.bannerNotification && (
            <>
              <MassActionBannerNotification
                url={config.registrationUrl.bannerNotification}
              />
              <OrderViewButtonBannerNotification
                url={config.registrationUrl.bannerNotification}
              />
            </>
          )}
        {config.registrationUrl && config.registrationUrl.orderCustomFee && (
          <OrderCustomFee url={config.registrationUrl.orderCustomFee} />
        )}
      </Extensible>
    </React.StrictMode>
  )
}
